"use strict";const e=require("./Link.js");module.exports=e;
//# sourceMappingURL=index.js.map
